import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import AboutMainImg from '../Img/About_Home_Img.png'
import AboutHomeClouds from '../Img/About_Home_clouds.png'

const subheading = "About Us";
const heading = "Trusted Manpower Solutions";

const paragraph =
  "At V9 Prime Force Pvt. Ltd., founded in 2018, we are committed to bridging the gap between businesses and top-tier talent. We specialize in providing complete HR and recruitment solutions tailored to the diverse and evolving needs of industries such as IT, healthcare, construction, and hospitality.";

const paragraph2 =
  "Our team of experienced recruiters and HR professionals takes the time to understand your unique business goals. We don’t just fill positions — we deliver individuals who fit your culture, contribute to growth, and become long-term assets to your organization.";


const splitWords = (text) => text.split(" ").map((word, i) => ({ word, key: i }));

const AboutHomeSection = () => {
  const textRef = useRef(null);
  const isInView = useInView(textRef, { once: true, margin: "-100px" });

  return (
    <div className="about-home-main-v9">
      <div className="about-home-wrapper-v9">
        <motion.div
          className="about-home-text-v9"
          ref={textRef}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.06,
              },
            },
          }}
        >
          {/* Subheading */}
          <motion.p className="about-home-subheading-v9">
            {splitWords(subheading).map(({ word, key }) => (
              <motion.span
                key={`sub-${key}`}
                className="about-home-heading-word-v9"
                variants={{
                  hidden: { opacity: 0, y: 15 },
                  visible: { opacity: 1, y: 0 },
                }}
              >
                {word}&nbsp;
              </motion.span>
            ))}
          </motion.p>

          {/* Heading */}
          <motion.h2 className="about-home-heading-v9">
            {splitWords(heading).map(({ word, key }) => (
              <motion.span
                key={`head-${key}`}
                className="about-home-heading-word-v9"
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 },
                }}
              >
                {word}&nbsp;
              </motion.span>
            ))}
          </motion.h2>

          {/* Paragraph 1 */}
          <motion.p className="about-home-paragraph-v9">
            {splitWords(paragraph).map(({ word, key }) => (
              <motion.span
                key={`para1-${key}`}
                className="about-home-heading-word-v9"
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 },
                }}
              >
                {word}&nbsp;
              </motion.span>
            ))}
          </motion.p>

          {/* Paragraph 2 */}
          <motion.p className="about-home-paragraph-v9">
            {splitWords(paragraph2).map(({ word, key }) => (
              <motion.span
                key={`para2-${key}`}
                className="about-home-heading-word-v9"
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 },
                }}
              >
                {word}&nbsp;
              </motion.span>
            ))}
          </motion.p>

          <motion.button
            className="about-home-cta-v9"
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0 },
            }}
            onClick={() => {
              window.location.href = '/about'; 
            }}
          >
            Read More
          </motion.button>
        </motion.div>

        {/* Image Column */}
        <motion.div
          className="about-home-image-v9"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={isInView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <img
            src={AboutMainImg}
            alt="V9 Primeforce team at work"
            className="about-home-img-v9"
          />
        </motion.div>
      </div>
      {/* <img src={AboutHomeClouds} alt="" className="about-home-clouds-v9" /> */}
    </div>
  );
};

export default AboutHomeSection;
